import React, { memo, ReactNode } from 'react';
import { useContextSelector } from 'use-context-selector';
import _ from 'lodash';

import styles from './Label.module.scss';
import { LabelContext } from './LabelContext';
import useLabel from './useLabel';

function Label(props: { children: ReactNode; wildcards?: object }) {
  const { labels, editing, addUntrackedLabel } = useContextSelector(
    LabelContext,
    (c) => c
  );
  const { label, getLabelKey, jsxToString } = useLabel();
  const { editMode, untrackedLabels } = editing;

  function hasLabel(text: string | ReactNode) {
    const key = getLabelKey(text);
    return !!_.get(labels, `${key}`);
  }

  const _label =
    label(props.children, { additionalWildcards: props.wildcards }) ||
    props.children;

  if (!editMode) return _label || null;

  const isLabelUntracked = editMode && !hasLabel(props.children);
  const isLabelTrackedInContext = _.get(
    untrackedLabels,
    getLabelKey(props.children)
  );

  const _className = [styles.Label__highlighted];
  !isLabelUntracked && _className.push(styles.Label__highlighted__tracked);
  isLabelTrackedInContext &&
    _className.push(styles.Label__highlighted__tracked__in__context);

  function handleClick(e: React.MouseEvent) {
    if (!isLabelUntracked) return;
    e.stopPropagation();
    e.preventDefault();
    addUntrackedLabel(getLabelKey(props.children), jsxToString(props.children));
  }

  return (
    <span className={_className.join(' ')} onClick={handleClick}>
      {_label}
    </span>
  );
}

export default memo(Label);
